import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit";

type SnackbarState = {
  isOpen: boolean;
  errorMessage: string;
  type: "success" | "info" | "warning" | "error";
};

export const AUTH_ACTIONS = {
  LOGOUT: "LOGOUT",
};

export const defaultErrorMessage =
  "Something went wrong! Please try again later or contact your developer for support";

const initialState: SnackbarState = {
  isOpen: false,
  errorMessage: "",
  type: "warning",
};

const snackbarSlice = createSlice({
  name: "snackbar",
  initialState,
  reducers: {
    showError: (
      state,
      { payload = defaultErrorMessage }: PayloadAction<string | undefined>
    ) => {
      state.isOpen = true;
      state.errorMessage = payload;
      state.type = "warning";
    },
    showInfo: (
      state,
      {
        payload,
      }: PayloadAction<{
        message: string;
        type: "success" | "info" | "warning" | "error";
      }>
    ) => {
      const { message, type } = payload;
      state.isOpen = true;
      state.errorMessage = message;
      state.type = type;
    },
    close: (state) => {
      state.isOpen = false;
      state.errorMessage = "";
    },
  },
});

function snackBarSelector(state: { [snackbarSlice.name]: SnackbarState }) {
  return state[snackbarSlice.name];
}

export const snackbarDataSelector = createSelector(
  snackBarSelector,
  (state: SnackbarState) => state
);

export default snackbarSlice;
